'use client'

import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { Box, Button, ImageList, ImageListItem, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { GALLERY_TYPE } from '../enum/enum_gallery'
import { decodeId } from '../../../../utils/app.utils'
import { FrontApi } from '../../../../api/front-api/front.api'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import GetAppIcon from '@mui/icons-material/GetApp';
import { RootState } from '../../../../store/store'
import PreviewImage from '../../../../components/preview-image/PreviewImage'
import { OptionContent } from '../../../../components/option-content/option_content'
import { likeContent, SOCIAL_MEDIA_TYPE } from '../../../../utils/global.func'
import SharedContent from '../../../../components/shared/SharedContent'
import { shareToFacebook, shareToLine, shareToX } from '../../../../utils/app.utils'
import { MediaItem } from '../element/element'
import { ImageContent } from '../../../../assets/background/background'
import clsx from 'clsx'
import { saveAs } from 'file-saver'
import moment from 'moment'
import { getVideoPoster } from '../page'
import Hashids from 'hashids'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}


type imageGalleryProps = {
    is_video?: boolean;
    itemData: { img: string, alt: string }[]
}

export const ImageListGallery: React.FC<imageGalleryProps> = ({ itemData, is_video }) => {
    return (
        <ImageList sx={{ width: "100%", height: "100%" }} cols={is_video ? 1 : 2} rowHeight={'auto'}>
            {is_video ? (
                <ImageListItem>
                    {itemData?.map((item, i) => {
                        return (
                            <MediaItem
                                key={i}
                                item={{
                                    url: item.img,
                                    img: item.img,
                                    alt: "",
                                    poster: ""
                                }} />
                        )
                    })}
                </ImageListItem>
            ) : (
                <>
                    {itemData.map((item) => {
                        return (
                            <ImageListItem key={item.img}>
                                <PreviewImage
                                    disable_show={false}
                                    image_url={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                                    disabled_max_width
                                    render_image={
                                        <img
                                            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                                            alt={item.alt}
                                            width={164}
                                            height={164}
                                            style={{
                                                objectFit: "cover",
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />
                                    }
                                />
                            </ImageListItem>
                        )
                    })}
                </>
            )}
        </ImageList>
    );
};
type relatedGalleryProps = {
    data: { title: string, img: string, alt: string, id_gallery: number }[];

}
export const RelatedGallery: React.FC<relatedGalleryProps> = ({ data }: relatedGalleryProps) => {
    const navigate = useNavigate();
    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);
    const [searchParams] = useSearchParams();
    const group_type = searchParams.get('GALLERY_TYPE');
    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams.toString())
            params.set(name, value)

            return params.toString()
        },
        [searchParams]
    )
    const encodeId = (id_gallery: number, gallery_type: string) => {
        const id = hash_ids.encode(id_gallery);
        navigate(routeName.main.galleryDetail.replace(":id_gallery", id) + "?" + createQueryString('GALLERY_TYPE', gallery_type))
    }
    return (
        <Box className="flex h-full overflow-visible gap-4 flex-col w-full">
            {data?.map((item, i) => {
                return (
                    <Box onClick={() => group_type && encodeId(item.id_gallery, group_type)} key={i} className="flex gap-4 cursor-pointer hover:opacity-70 transition-all h-full p-4 flex-col w-full">
                        <Box className="w-full relative rounded-[8px] overflow-hidden h-[300px]">
                            <img
                                src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                                alt={item.alt}
                                // width={"100%"}
                                style={{
                                    objectFit: "cover",
                                    width: "100%",
                                    height: "100%",
                                }}
                            />
                        </Box>
                        <Box>
                            <Typography className='line-clamp-2'>
                                {item.title || ""}
                            </Typography>
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}

const GalleryDetail: React.FC<Props> = ({ }: Props) => {
    const dispatch = useDispatch();
    const { id_gallery } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const id = decodeId(id_gallery || "");
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const group_type = searchParams.get('GALLERY_TYPE');
    const path_name = location.pathname;
    const base_url = useSelector((state: RootState) => state.api.image_api);
    const base_url_content = useSelector((state: RootState) => state.api.public_content_api);
    const is_video: boolean = GALLERY_TYPE.VDO === group_type ? true : false;

    const content_url = base_url_content + path_name + "?" + "GALLERY_TYPE=" + group_type
    const [dataDetail, setDataDetail] = useState<any>(null);

    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams.toString())
            params.set(name, value)

            return params.toString()
        },
        [searchParams]
    )


    const handleDownloadImage = async (id_gallery: number) => {
        dispatch(setLoading());
        await FrontApi.downloadGalleryImage(id_gallery).then((res) => {
            if (res.status < 300) {
                const data = res.data;
                const blob_file = new Blob([data], { type: 'application/zip' })
                saveAs(blob_file, `image_file_${moment().format("DD_MM_YYYY_HH_mm")}`);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetDetail = async (id_gallery: number) => {
        dispatch(setLoading());
        await FrontApi.findOneGallery(id_gallery).then((res) => {
            if (res.status < 300) {
                const data = res.data?.data;
                const test_related_gallery = data?.related_gallery || [];
                setDataDetail({
                    ...data,
                    // related_gallery: [...test_related_gallery, ...test_related_gallery, ...test_related_gallery, ...test_related_gallery, ...test_related_gallery]
                });
                // console.log(data, 'data')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    useEffect(() => {
        if (id) {
            handleGetDetail(id)
        }
    }, [id])
    return (
        <Box className="w-full px-4 py-10 h-auto m-auto min-h-screen md:max-w-[1136px] lg:max-w-[1146px]">
            <NavigateListCustom
                navigateData={[
                    {
                        key: "1",
                        name: t("แกลเลอรี่"),
                        pathName: routeName.main.galleryList
                    },
                    {
                        key: "2",
                        name: GALLERY_TYPE.IMAGE === group_type ? t("HOME_PAGE_PHOTO") : t("HOME_PAGE_VIDEO"),
                        searchParams: group_type ? {
                            GALLERY_TYPE: group_type
                        } : undefined,
                        pathName: routeName.main.galleryList
                    },
                    {
                        key: "3",
                        name: dataDetail?.gallery_name || "-",
                        pathName: path_name
                    },
                ]}
            />


            <Box className='grid grid-cols-12 gap-4 py-10' component={"section"}>
                <Box className={clsx('col-span-12', {
                    'col-span-12': GALLERY_TYPE.IMAGE === group_type,
                    'xl:col-span-8': GALLERY_TYPE.VDO === group_type
                })}>
                    {GALLERY_TYPE.IMAGE === group_type && (
                        <Box className="w-full flex flex-col md:flex-row justify-between gap-2" py={"40px"}>
                            <Box className="flex flex-col gap-2">
                                <Typography variant='h5'>
                                    {dataDetail?.gallery_name || "-"}
                                </Typography>
                                <Typography variant='subtitle2'>
                                    {t("HOME_PAGE_CATEGORY")} : {dataDetail?.gallery_type_name || "-"}
                                </Typography>
                            </Box>
                            {GALLERY_TYPE.IMAGE === group_type && (
                                <Box>
                                    <Button onClick={() => dataDetail?.id_gallery && handleDownloadImage(dataDetail?.id_gallery)} variant='contained' color='success' fullWidth startIcon={<GetAppIcon />}>{t("HOME_PAGE_DOWNLOAD_ALL")}</Button>
                                </Box>
                            )}
                        </Box>
                    )}
                    <Box className="grid grid-cols-12 gap-4">
                        <Box className={clsx('col-span-12 w-full h-fit overflow-auto', {
                            'max-h-[756px] min-h-[756px]': GALLERY_TYPE.IMAGE === group_type,
                        })}>
                            {dataDetail?.file?.length > 0 ? (
                                <ImageListGallery
                                    is_video={GALLERY_TYPE.VDO === group_type}
                                    itemData={dataDetail?.file?.map((list: any) => {
                                        const url = (is_video && !list?.media_file_path) ? list?.gallery_link : list?.media_file_path ? `${base_url}/${list?.media_file_path}${list?.media_file_name}` : ImageContent.noImage
                                        return {
                                            img: url,
                                            alt: url
                                        }
                                    })}
                                />
                            ) : undefined}

                            {GALLERY_TYPE.VDO === group_type && (
                                <Box className="w-full flex flex-col md:flex-row justify-between gap-2" py={"40px"}>
                                    <Box className="flex flex-col gap-2">
                                        <Typography variant='h5'>
                                            {dataDetail?.gallery_name || "-"}
                                        </Typography>
                                        <Typography variant='subtitle2'>
                                            {t("HOME_PAGE_CATEGORY")} : {dataDetail?.gallery_type_name || "-"}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                            {GALLERY_TYPE.VDO === group_type && (
                                <Box className="w-full flex flex-col xl:flex-row justify-center xl:justify-between items-center">
                                    <Box>
                                        <OptionContent
                                            date_row
                                            date={dataDetail?.start_date || ""}
                                            count={{
                                                onLikeClick: () => likeContent(dataDetail?.id_gallery, +dataDetail?.is_like ? 'DISLIKE' : 'LIKE', 'GALLERY', (_, id, type) => {
                                                    setDataDetail((prev: any) => ({
                                                        ...prev,
                                                        total_like: type === 'LIKE' ? prev?.total_like + 1 : prev?.total_like - 1,
                                                        is_like: type === 'LIKE' ? true : false
                                                    }))
                                                }),
                                                view: dataDetail?.total_view || 0,
                                                like: dataDetail?.total_like || 0,
                                                like_checked: +dataDetail?.is_like ? true : false,
                                                shared: dataDetail?.total_shared || 0,
                                                onSharedClick: {
                                                    facebookClick: () => {
                                                        likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                            setDataDetail((prev: any) => ({
                                                                ...prev,
                                                                total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                                        shareToFacebook(content_url)
                                                    },
                                                    lineClick: () => {
                                                        likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                            setDataDetail((prev: any) => ({
                                                                ...prev,
                                                                total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.LINE)
                                                        shareToLine(content_url, dataDetail?.gallery_name)
                                                    },
                                                    xClick: () => {
                                                        likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                            setDataDetail((prev: any) => ({
                                                                ...prev,
                                                                total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.X)
                                                        shareToX(content_url, dataDetail?.gallery_name)
                                                    },
                                                }
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <SharedContent
                                            copy={content_url}
                                            facebook_link={content_url}
                                            line_link={content_url}
                                            textLine={dataDetail?.gallery_name || ""}
                                            textX={dataDetail?.gallery_name || ""}
                                            x_link={content_url}
                                            callback_facebook_click={() => {
                                                likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                    setDataDetail((prev: any) => ({
                                                        ...prev,
                                                        total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                    }))
                                                }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                            }}
                                            callback_line_click={() => {
                                                likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                    setDataDetail((prev: any) => ({
                                                        ...prev,
                                                        total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                    }))
                                                }, SOCIAL_MEDIA_TYPE.LINE)
                                            }}
                                            callback_x_click={() => {
                                                likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                    setDataDetail((prev: any) => ({
                                                        ...prev,
                                                        total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                    }))
                                                }, SOCIAL_MEDIA_TYPE.X)
                                            }}
                                        />
                                    </Box>
                                </Box>
                            )}
                        </Box>


                        {GALLERY_TYPE.IMAGE === group_type && (
                            <Box className="col-span-12 flex flex-col xl:flex-row justify-center xl:justify-between items-center">
                                <Box>
                                    <OptionContent
                                        date_row
                                        date={dataDetail?.start_date || ""}
                                        count={{
                                            onLikeClick: () => likeContent(dataDetail?.id_gallery, +dataDetail?.is_like ? 'DISLIKE' : 'LIKE', 'GALLERY', (_, id, type) => {
                                                setDataDetail((prev: any) => ({
                                                    ...prev,
                                                    total_like: type === 'LIKE' ? prev?.total_like + 1 : prev?.total_like - 1,
                                                    is_like: type === 'LIKE' ? true : false
                                                }))
                                            }),
                                            view: dataDetail?.total_view || 0,
                                            like: dataDetail?.total_like || 0,
                                            like_checked: +dataDetail?.is_like ? true : false,
                                            shared: dataDetail?.total_shared || 0,
                                            onSharedClick: {
                                                facebookClick: () => {
                                                    likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                        setDataDetail((prev: any) => ({
                                                            ...prev,
                                                            total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                                    shareToFacebook(content_url)
                                                },
                                                lineClick: () => {
                                                    likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                        setDataDetail((prev: any) => ({
                                                            ...prev,
                                                            total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.LINE)
                                                    shareToLine(content_url, dataDetail?.gallery_name)
                                                },
                                                xClick: () => {
                                                    likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                        setDataDetail((prev: any) => ({
                                                            ...prev,
                                                            total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.X)
                                                    shareToX(content_url, dataDetail?.gallery_name)
                                                },
                                            }
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <SharedContent
                                        copy={content_url}
                                        facebook_link={content_url}
                                        line_link={content_url}
                                        textLine={dataDetail?.gallery_name || ""}
                                        textX={dataDetail?.gallery_name || ""}
                                        x_link={content_url}
                                        callback_facebook_click={() => {
                                            likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                setDataDetail((prev: any) => ({
                                                    ...prev,
                                                    total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                        }}
                                        callback_line_click={() => {
                                            likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                setDataDetail((prev: any) => ({
                                                    ...prev,
                                                    total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.LINE)
                                        }}
                                        callback_x_click={() => {
                                            likeContent(dataDetail?.id_gallery, 'SHARED', 'GALLERY', (st, id) => {
                                                setDataDetail((prev: any) => ({
                                                    ...prev,
                                                    total_shared: st ? prev?.total_shared + 1 : prev?.total_shared
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.X)
                                        }}
                                    />
                                </Box>
                            </Box>
                        )}
                    </Box>

                </Box>
                {group_type === GALLERY_TYPE.VDO && (
                    <Box className="col-span-12 xl:col-span-4 h-full">
                        <Box className="h-full col-span-12 xl:col-span-4">
                            <RelatedGallery
                                data={dataDetail?.related_gallery?.length > 0 ?
                                    dataDetail?.related_gallery?.map((list: any) => {
                                        const url = list?.gallery_link ? getVideoPoster(list?.gallery_link || "") : list?.media_file_path ? `${base_url}/${list?.media_file_path}${list?.media_file_name}` : ImageContent.noImage
                                        return {
                                            id_gallery: list?.id_gallery,
                                            title: list?.gallery_name,
                                            img: url,
                                            alt: url
                                        }
                                    }) : []}
                            />
                        </Box>
                    </Box>
                )}
            </Box>



        </Box>
    )
}

export default GalleryDetail